import React from "react";

function FloatingButton({ func, title }) {
  return (
    <div className="fixed bottom-10 right-5 md:right-10 z-20">
      <button
        type="button"
        className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-2xl text-sm w-full sm:w-auto px-5 py-2.5 text-center"
        onClick={func}
      >
        {title}
      </button>
    </div>
  );
}

export default FloatingButton;
